<template>
  <div class="pta-pipeline-test2">
    <h1>Pipeline</h1>
    <p>Follow the progress of your fundraising efforts and see which investors have shown interest in your offering.</p>
<div v-if="cur_user_id!=264">
    <img src="/images/pipeline_preview.png?t=2" style="width:100%;max-width:1280px;display:block;" />
    <br /> <br /><a href="/account/calendar" class="pta-button">PROCEED TO BOOK A CALL WITH US</a>
</div>
    <div v-else>
    <div class="pta-pipeline-status">
      <ul>
        <li><span>5</span>Active Deals</li>
        <li><span>£5,000.00</span>Average Deal Value</li>
        <li><span>0%</span>Success Rate</li>
        <li><span>2 <i>Days</i></span>Average Deal Lifespan</li>
      </ul>
    </div>
    <div class="pta-pipeline-sort">
      <ul>
        <li :class="pta_sort_by=='created'?(pta_sort_dir=='asc'?'active-asc':'active-desc'):''" @click.prevent="pta_sort_by='created'?(pta_sort_dir=='desc'?pta_sort_dir='asc':pta_sort_dir='desc'):pta_sort_dir='asc';pta_sort_by='created';"><span>Date created</span></li>
        <li :class="pta_sort_by=='name'?(pta_sort_dir=='asc'?'active-asc':'active-desc'):''" @click.prevent="pta_sort_by='name'?(pta_sort_dir=='desc'?pta_sort_dir='asc':pta_sort_dir='desc'):pta_sort_dir='asc';pta_sort_by='name';"><span>Name</span></li>
        <li :class="pta_sort_by=='value'?(pta_sort_dir=='asc'?'active-asc':'active-desc'):''" @click.prevent="pta_sort_by='value'?(pta_sort_dir=='desc'?pta_sort_dir='asc':pta_sort_dir='desc'):pta_sort_dir='asc';pta_sort_by='value';"><span>Value</span></li>
        <li :class="pta_sort_by=='close'?(pta_sort_dir=='asc'?'active-asc':'active-desc'):''" @click.prevent="pta_sort_by='close'?(pta_sort_dir=='desc'?pta_sort_dir='asc':pta_sort_dir='desc'):pta_sort_dir='asc';pta_sort_by='close';"><span>Close date</span></li>
        <li :class="pta_sort_by=='updates'?(pta_sort_dir=='asc'?'active-asc':'active-desc'):''" @click.prevent="pta_sort_by='updates'?(pta_sort_dir=='desc'?pta_sort_dir='asc':pta_sort_dir='desc'):pta_sort_dir='asc';pta_sort_by='updates';"><span>Last updates</span></li>
        <li :class="pta_sort_by=='state'?(pta_sort_dir=='asc'?'active-asc':'active-desc'):''" @click.prevent="pta_sort_by='state'?(pta_sort_dir=='desc'?pta_sort_dir='asc':pta_sort_dir='desc'):pta_sort_dir='asc';pta_sort_by='state';"><span>State</span></li>
      </ul>
    </div>
    <div class="pta-pipeline-campaigns">
      <div class="pta-pipeline-campaign">
        <div class="pta-pipeline-campaign-left">
          <h3>Sanchis Miguel</h3>
        </div>
        <div class="pta-pipeline-campaign-right">
          <span class="pta-pipeline-amount">£1,000.00</span>
          <span class="pta-pipeline-date">08.06.2023</span>
        </div>
        <div class="pta-pipeline-campaign-left">
          <ul class="pta-pipeline-statusline pta-pipeline-color-1 pta-pipeline-size-9" :class="show_index==1?'pta-pipeline-show-labels':''">
            <li class="active"><div><span>Conversation started</span></div></li>
            <li><div><span>Fact Sheet</span></div></li>
            <li><div><span>Presentation</span></div></li>
            <li><div><span>Team Bios</span></div></li>
            <li><div><span>Case Studies</span></div></li>
            <li><div><span>FAQ/DDQ</span></div></li>
            <li><div><span>Track Record</span></div></li>
            <li><div><span>Financial Model</span></div></li>
            <li><div><span>Key Terms</span></div></li>
            <li><div><span>Market Reports</span></div></li>
          </ul>
          <i @click.prevent="show_index==1?show_index=0:show_index=1" class="pta-pipeline-icon-show" :class="show_index==1?'pta-pipeline-icon-hide':''"></i>
        </div>
        <div class="pta-pipeline-campaign-right">
          <span class="pta-pipeline-button" @click.prevent="selected_index==1?selected_index=0:selected_index=1">View details</span>
        </div>
        <div class="pta-pipeline-campaign-details" v-if="selected_index==1">
          No information available yet.
        </div>
      </div>
      <div class="pta-pipeline-campaign">
        <div class="pta-pipeline-campaign-left">
          <h3>PropTech Admin</h3>
        </div>
        <div class="pta-pipeline-campaign-right">
          <span class="pta-pipeline-amount">£1,000.00</span>
          <span class="pta-pipeline-date">08.06.2023</span>
        </div>
        <div class="pta-pipeline-campaign-left">
          <ul class="pta-pipeline-statusline pta-pipeline-color-2 pta-pipeline-size-9" :class="show_index==1?'pta-pipeline-show-labels':''">
            <li class="active"><div><span>Conversation started</span></div></li>
            <li><div><span>Fact Sheet</span></div></li>
            <li><div><span>Presentation</span></div></li>
            <li><div><span>Team Bios</span></div></li>
            <li><div><span>Case Studies</span></div></li>
            <li><div><span>FAQ/DDQ</span></div></li>
            <li><div><span>Track Record</span></div></li>
            <li><div><span>Financial Model</span></div></li>
            <li><div><span>Key Terms</span></div></li>
            <li><div><span>Market Reports</span></div></li>
          </ul>
          <i @click.prevent="show_index==1?show_index=0:show_index=1" class="pta-pipeline-icon-show" :class="show_index==1?'pta-pipeline-icon-hide':''"></i>
        </div>
        <div class="pta-pipeline-campaign-right">
          <span class="pta-pipeline-button" @click.prevent="selected_index==1?selected_index=0:selected_index=1">View details</span>
        </div>
        <div class="pta-pipeline-campaign-details" v-if="selected_index==1">
          No information available yet.
        </div>
      </div>
      <div class="pta-pipeline-campaign">
        <div class="pta-pipeline-campaign-left">
          <h3>Jerry Meyer</h3>
        </div>
        <div class="pta-pipeline-campaign-right">
          <span class="pta-pipeline-amount">£1,000.00</span>
          <span class="pta-pipeline-date">08.06.2023</span>
        </div>
        <div class="pta-pipeline-campaign-left">
          <ul class="pta-pipeline-statusline pta-pipeline-color-3 pta-pipeline-size-9" :class="show_index==1?'pta-pipeline-show-labels':''">
            <li class="active"><div><span>Conversation started</span></div></li>
            <li><div><span>Fact Sheet</span></div></li>
            <li><div><span>Presentation</span></div></li>
            <li><div><span>Team Bios</span></div></li>
            <li><div><span>Case Studies</span></div></li>
            <li><div><span>FAQ/DDQ</span></div></li>
            <li><div><span>Track Record</span></div></li>
            <li><div><span>Financial Model</span></div></li>
            <li><div><span>Key Terms</span></div></li>
            <li><div><span>Market Reports</span></div></li>
          </ul>
          <i @click.prevent="show_index==1?show_index=0:show_index=1" class="pta-pipeline-icon-show" :class="show_index==1?'pta-pipeline-icon-hide':''"></i>
        </div>
        <div class="pta-pipeline-campaign-right">
          <span class="pta-pipeline-button" @click.prevent="selected_index==1?selected_index=0:selected_index=1">View details</span>
        </div>
        <div class="pta-pipeline-campaign-details" v-if="selected_index==1">
          No information available yet.
        </div>
      </div>
      <div class="pta-pipeline-campaign">
        <div class="pta-pipeline-campaign-left">
          <h3>Lewis Johnson</h3>
        </div>
        <div class="pta-pipeline-campaign-right">
          <span class="pta-pipeline-amount">£1,000.00</span>
          <span class="pta-pipeline-date">08.06.2023</span>
        </div>
        <div class="pta-pipeline-campaign-left">
          <ul class="pta-pipeline-statusline pta-pipeline-color-4 pta-pipeline-size-9" :class="show_index==1?'pta-pipeline-show-labels':''">
            <li class="active"><div><span>Conversation started</span></div></li>
            <li><div><span>Fact Sheet</span></div></li>
            <li><div><span>Presentation</span></div></li>
            <li><div><span>Team Bios</span></div></li>
            <li><div><span>Case Studies</span></div></li>
            <li><div><span>FAQ/DDQ</span></div></li>
            <li><div><span>Track Record</span></div></li>
            <li><div><span>Financial Model</span></div></li>
            <li><div><span>Key Terms</span></div></li>
            <li><div><span>Market Reports</span></div></li>
          </ul>
          <i @click.prevent="show_index==1?show_index=0:show_index=1" class="pta-pipeline-icon-show" :class="show_index==1?'pta-pipeline-icon-hide':''"></i>
        </div>
        <div class="pta-pipeline-campaign-right">
          <span class="pta-pipeline-button" @click.prevent="selected_index==1?selected_index=0:selected_index=1">View details</span>
        </div>
        <div class="pta-pipeline-campaign-details" v-if="selected_index==1">
          No information available yet.
        </div>
      </div>
      <div class="pta-pipeline-campaign">
        <div class="pta-pipeline-campaign-left">
          <h3>Romeu Sanchis</h3>
        </div>
        <div class="pta-pipeline-campaign-right">
          <span class="pta-pipeline-amount">£1,000.00</span>
          <span class="pta-pipeline-date">08.06.2023</span>
        </div>
        <div class="pta-pipeline-campaign-left">
          <ul class="pta-pipeline-statusline pta-pipeline-color-5 pta-pipeline-size-9" :class="show_index==1?'pta-pipeline-show-labels':''">
            <li class="active"><div><span>Conversation started</span></div></li>
            <li><div><span>Fact Sheet</span></div></li>
            <li><div><span>Presentation</span></div></li>
            <li><div><span>Team Bios</span></div></li>
            <li><div><span>Case Studies</span></div></li>
            <li><div><span>FAQ/DDQ</span></div></li>
            <li><div><span>Track Record</span></div></li>
            <li><div><span>Financial Model</span></div></li>
            <li><div><span>Key Terms</span></div></li>
            <li><div><span>Market Reports</span></div></li>
          </ul>
          <i @click.prevent="show_index==1?show_index=0:show_index=1" class="pta-pipeline-icon-show" :class="show_index==1?'pta-pipeline-icon-hide':''"></i>
        </div>
        <div class="pta-pipeline-campaign-right">
          <span class="pta-pipeline-button" @click.prevent="selected_index==1?selected_index=0:selected_index=1">View details</span>
        </div>
        <div class="pta-pipeline-campaign-details" v-if="selected_index==1">
          No information available yet.
        </div>
      </div>
    </div>
    </div>
  </div>

</template>
<script>
export default {
  components: {},
  mounted(){
    this.cur_user_id = helper.getAuthUser('id');
  },
  methods: {},
  data() {
    return {
      pta_sort_by: 'created',
      pta_sort_dir: 'asc',
      selected_index: 0,
      show_index: 0,
      cur_user: '',
      cur_user_id: 0
    }
  },
  computed: {
  },
  filters: {
  },
}
</script>
<style scope>


.pta-pipeline-test2 .pta-pipeline-icon-show{
  display:inline-block;
  height:20px;
  width:20px;
  background:transparent url(/images/icon_show.svg) no-repeat top left;
  background-size:100% auto;
  margin-left:-10px;
  cursor: pointer;
}
.pta-pipeline-test2 .pta-pipeline-icon-show.pta-pipeline-icon-hide{
  background-image:url(/images/icon_hide.svg);
}
.pta-pipeline-test2 .pta-pipeline-statusline{
  list-style: none;
  margin:0;
  padding:0;
  margin-top:5px;
  width:calc(100% - 30px);
  display:inline-block;
}
.pta-pipeline-test2 .pta-pipeline-statusline:after{
  content: "";
  clear: both;
  display: table;
}
.pta-pipeline-test2 .pta-pipeline-size-6 li{
  float:left;
  width:calc(20% - 4px);
  height:20px;
  position: relative;
}
.pta-pipeline-test2 .pta-pipeline-campaign-details{
  padding-top:20px;
  font-size:16px;
  clear:left;
}
.pta-pipeline-test2 .pta-pipeline-size-6 li:first-child{
  float:left;
  width:20px;
  height:20px;
  position: relative;
}
.pta-pipeline-test2 .pta-pipeline-size-9 li{
  float:left;
  width:calc(11.1111111% - 4px);
  height:20px;
  position: relative;
}
.pta-pipeline-test2 .pta-pipeline-size-9 li:first-child{
  float:left;
  width:20px;
  height:20px;
  position: relative;
}
.pta-pipeline-test2 .pta-pipeline-statusline li div{
  position: absolute;
  height:20px;
  width:20px;
  right:0;
  top:0;
  z-index:3;
}
.pta-pipeline-test2 .pta-pipeline-statusline.pta-pipeline-show-labels li div span {
  display: block;
}
.pta-pipeline-test2 .pta-pipeline-statusline li div span{
  display:none;
  position:absolute;
  top:-40px;
  background:#000;
  color:#fff;
  font-size:12px;
  padding:5px 10px;
  border-radius: 5px;
  white-space:nowrap;
  left:-18px;
}
.pta-pipeline-test2 .pta-pipeline-statusline li div span:after{
  content: '';
  width: 16px;
  position: absolute;
  bottom: -8px;
  left: 20px;
  height: 14px;
  background:transparent url(/images/icon_arrow_sort_down.svg) no-repeat top left;
  background-size:100% auto;
}
.pta-pipeline-test2 .pta-pipeline-statusline li div:hover span{
  display:inline-block;
}
.pta-pipeline-test2 .pta-pipeline-statusline li:after{
  content:'';
  width:100%;
  position: absolute;
  top:7px;
  left:0;
  height:6px;
  border-top:1px solid #cccccc;
  border-bottom:1px solid #cccccc;
  z-index:1;
  background:#efefef;
}
.pta-pipeline-test2 .pta-pipeline-statusline li:before{
  content:'';
  width:20px;
  position: absolute;
  top:0px;
  right:0;
  height:20px;
  background:#efefef;
  border:1px solid #cccccc;
  border-radius: 20px;
  z-index:2;
}
.pta-pipeline-test2 .pta-pipeline-statusline.pta-pipeline-color-1 li.active:before,
.pta-pipeline-test2 .pta-pipeline-statusline.pta-pipeline-color-1 li.active:after{
  border:0;
  background-color:#f69d1d;
}
.pta-pipeline-test2 .pta-pipeline-statusline.pta-pipeline-color-2 li.active:before,
.pta-pipeline-test2 .pta-pipeline-statusline.pta-pipeline-color-2 li.active:after{
  border:0;
  background-color:#8b84ca;
}
.pta-pipeline-test2 .pta-pipeline-statusline.pta-pipeline-color-3 li.active:before,
.pta-pipeline-test2 .pta-pipeline-statusline.pta-pipeline-color-3 li.active:after{
  border:0;
  background-color:#f86e54;
}
.pta-pipeline-test2 .pta-pipeline-statusline.pta-pipeline-color-4 li.active:before,
.pta-pipeline-test2 .pta-pipeline-statusline.pta-pipeline-color-4 li.active:after{
  border:0;
  background-color:#19d18b;
}
.pta-pipeline-test2 .pta-pipeline-statusline.pta-pipeline-color-5 li.active:before,
.pta-pipeline-test2 .pta-pipeline-statusline.pta-pipeline-color-5 li.active:after{
  border:0;
  background-color:#b57ed1;
}



.pta-pipeline-test2 .pta-pipeline-campaign{
  border-radius:10px;
  background:#fff;
  padding:20px;
  margin-top:20px;
}
.pta-pipeline-test2 .pta-pipeline-campaign:after{
  content: "";
  clear: both;
  display: table;
}
.pta-pipeline-test2 .pta-pipeline-campaign span{
  display:block;
}
.pta-pipeline-test2 .pta-pipeline-campaign h3{
  font-weight:600;
  font-size:20px;
  line-height:26px;
}
.pta-pipeline-test2 .pta-pipeline-campaign h4{
  font-weight:400;
  font-size:16px;
  margin-bottom:10px;
}
.pta-pipeline-test2 .pta-pipeline-amount{
  font-weight:600;
  font-size:22px;
  text-align: right;
}
.pta-pipeline-test2 .pta-pipeline-campaign span.pta-pipeline-date{
  font-size:16px;
  line-height:16px;
  text-align: right;
  display:inline-block;
  padding-left:24px;
  background: transparent url(/images/icon_calendar.svg) no-repeat left top;
  background-size: auto 100%;
  float: right;
  margin-top: 4px;
}
.pta-pipeline-test2 .pta-pipeline-campaign-right,
.pta-pipeline-test2 .pta-pipeline-campaign-left{
  float:left;
}
.pta-pipeline-test2 .pta-pipeline-campaign-right{
  width:120px;
}
.pta-pipeline-test2 .pta-pipeline-campaign-left{
  width:calc(100% - 120px);
  padding-right:40px;
  clear:left;
}
.pta-pipeline-test2 .pta-pipeline-campaigns{
  margin-top:20px;
}


.pta-pipeline-test2 .pta-pipeline-button {
  background: #34A7C2;
  display: inline-block;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 14px;
  padding: 8px 10px;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  cursor:pointer;
  text-align:center;
}

.pta-pipeline-test2 .pta-pipeline-sort ul{
  list-style:none;
  width:100%;
  margin:0;
  padding:0;
}
.pta-pipeline-test2 .pta-pipeline-sort ul:after{
  content: "";
  clear: both;
  display: table;
}
.pta-pipeline-test2 .pta-pipeline-sort ul li{
  float:left;
  width:16.66666666666667%;
  background:#ffffff;
  padding:10px;
  font-size:14px;
  line-height: 14px;
  text-align: center;
  font-weight: 600;
  cursor:pointer;
}
.pta-pipeline-test2 .pta-pipeline-sort ul li.active-desc,
.pta-pipeline-test2 .pta-pipeline-sort ul li.active-asc{
  background-color:#34A7C2;
  color:#fff;
}
.pta-pipeline-test2 .pta-pipeline-sort ul li.active-desc span{
  background-image:url(/images/icon_arrow_sort_down_white.svg);
}
.pta-pipeline-test2 .pta-pipeline-sort ul li.active-asc span{
  background-image:url(/images/icon_arrow_sort_top_white.svg);
}
.pta-pipeline-test2 .pta-pipeline-sort ul li span{
  display: inline-block;
  padding-left:20px;
  background:transparent url(/images/icon_arrow_sort_topdown.svg) no-repeat left center;
  background-size:10px auto;
}
.pta-pipeline-test2 .pta-pipeline-sort ul li:last-child{
  -webkit-border-bottom-right-radius: 10px;
  -moz-border-radius-bottomright: 10px;
  border-bottom-right-radius: 10px;
}
.pta-pipeline-test2 .pta-pipeline-sort ul li:first-child{
  -webkit-border-bottom-left-radius: 10px;
  -moz-border-radius-bottomleft: 10px;
  border-bottom-left-radius: 10px;
}


.pta-pipeline-test2 .pta-pipeline-status ul{
  list-style:none;
  width:100%;
  margin:0;
  padding:0;
  margin-bottom:4px;
}
.pta-pipeline-test2 .pta-pipeline-status ul:after{
  content: "";
  clear: both;
  display: table;
}
.pta-pipeline-test2 .pta-pipeline-status ul li{
  float:left;
  margin-right:4px;
  width:calc(30% - 3px);
  background:#ffffff;
  text-align:center;
  height:110px;
  padding:20px 20px 0;
  font-size:16px;
}
.pta-pipeline-test2 .pta-pipeline-status ul li span{
  display:block;
  font-size:24px;
  font-weight:600;
  margin-bottom:0px;
}
.pta-pipeline-test2 .pta-pipeline-status ul li span i{
  font-style: normal;
  font-size:18px;
}
.pta-pipeline-test2 .pta-pipeline-status ul li:nth-child(2){
  width:calc(40% - 3px);
}
.pta-pipeline-test2 .pta-pipeline-status ul li:last-child{
  margin-right:0px;
  -webkit-border-top-right-radius: 10px;
  -moz-border-radius-topright: 10px;
  border-top-right-radius: 10px;
}
.pta-pipeline-test2 .pta-pipeline-status ul li:first-child{
  -webkit-border-top-left-radius: 10px;
  -moz-border-radius-topleft: 10px;
  border-top-left-radius: 10px;
}
</style>